import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "operator",
})
export class OperatorPipe implements PipeTransform {
  transform(value: string): any {
    switch (value) {
      case "+":
        return "plus";
      case "-":
        return "minus";
      case "×":
        return "multiply";
      case "/":
        return "divide";
      default:
        return "other";
    }
  }
}
